import styled from "styled-components";
import { colors } from "../../../../utils/colors";

export const Outer = styled.div`
    padding: 24px;
    background-color: ${colors.brandXXXLight};
    border-radius: 20px;
    margin-bottom: 24px;
`;

export const Header = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 16px;
`;

export const IconCircle = styled.div`
    width: 54px;
    height: 54px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.brandDark};
    flex-shrink: 0;
    color: white;
`;

export const Title = styled.p`
    margin: 0;
    font-size: 18px;
    font-weight: bold;
`;

export const Copy = styled.p`
    margin-top: 16px;
    font-size: 16px;
`;

export const ButtonWrapper = styled.div`
    margin-top: 24px;
`;
